import { render, staticRenderFns } from "./RSVPList.vue?vue&type=template&id=4b1754fd"
import script from "./RSVPList.vue?vue&type=script&lang=js"
export * from "./RSVPList.vue?vue&type=script&lang=js"
import style0 from "./RSVPList.vue?vue&type=style&index=0&id=4b1754fd&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports